/**
 * @author Charles Carlson
 * @copyright Copyright 2026 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2026-08-18
 * @description Implementation of gtag event names.
 * @filename gtag-event-names.ts
 */
export const EVENT_NAMES = {
  LOGIN_EVENT: "login_event",
  LOGOUT_EVENT: "logout_event",
  REGISTRATION_EVENT: "signup_event",
  PAGE_VIEW_EVENT: "page_view_event",
  TIME_ON_PAGE_EVENT: "time_on_page_event",
  CONTENT_CLICK_EVENT: "content_click_event",
  SUPPORT_EVENT: "support_event",
  PERSON_INFO_CLICK_EVENT: "person_click_event",
  VIDEO_PROGRESS_EVENT: "video_progress_event",
  SAVED_ITEM_EVENT: "saved_item_event",
  RSVP_EVENT: "rsvp_event",
} as const;
